export default "__VITE_ASSET__CHkVp4fO__"